import { Button, DeletePass } from '@doda/io-react/common';
import { FC } from 'react';
import { makeStaticUrl } from '@doda/common/src/logics/staticUrl';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { useRouter } from 'next/router';
import {
  deleteCookie,
  getCookie,
  setCookie,
} from '@doda/common/src/utils/cookieUtil';
import { COOKIE } from '@doda/common/src/constants/cookie';
import {
  USER_CLICK_HISTORYDETAIL,
  USER_CLICK_HISTORYLIST,
  generateUrl,
} from 'components/FollowSearchResultsNavigation/logics/generateUrl';
import styles from './index.module.scss';
import { HistoryJobsProps } from '../HistoryJobs';

/**
 * 最近見た求人 コンテンツ
 * @param onClickShowConfirm 一括削除確認の表示用クリックイベント
 */
interface Props {
  historyList: HistoryJobsProps['historyList'];
  loginStatus: HistoryJobsProps['loginStatus'];
  onClickShowConfirm: () => void;
  updateHistoryList: HistoryJobsProps['updateHistoryList'];
}

export const HistoryJobsContents: FC<Props> = ({
  historyList,
  loginStatus,
  onClickShowConfirm,
  updateHistoryList,
}) => {
  const router = useRouter();

  // 押下された閲覧履歴のみ削除
  const onClickDeleteHistory = (jid: string | undefined) => {
    if (!jid) return;
    const cookieValue = getCookie(COOKIE.HISTORYID);
    const historyId = cookieValue.split(';').filter((cookie) => {
      return !cookie.startsWith(jid);
    });
    const newHistoryId = historyId.join(';');
    deleteCookie(COOKIE.HISTORYID);
    setCookie(COOKIE.HISTORYID, newHistoryId, {});
    const newHistoryList = historyList?.filter((item) => item.jid !== jid);
    updateHistoryList(newHistoryList);
  };

  // 求人IDをもとに求人詳細URLを生成
  const createJobSearchDetailUrl = (jid: string | undefined) => {
    if (!jid) return '';
    const path = DODA_SITE_URL.jobSearchDetail;
    const params = { jid };
    const url = generateUrl({
      baseUrl: makeStaticUrl(params, path),
      userClickList: USER_CLICK_HISTORYDETAIL,
      pathname: router.pathname,
      loginStatus,
    });
    return url;
  };

  return (
    <div className={styles.contentsWrapper}>
      <ul className={styles.contentsWrapper__lists}>
        {historyList?.map(({ jid, corporateName, occupationName }) => (
          <li key={jid} className={styles.contentsWrapper__listItem}>
            <a
              href={createJobSearchDetailUrl(jid)}
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.contentsWrapper__companyName}>
                {corporateName}
              </p>
              <p className={styles.contentsWrapper__jobName}>
                {occupationName}
              </p>
            </a>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onClickDeleteHistory(jid);
              }}
              className={styles.contentsWrapper__deleteBtn}
            >
              <DeletePass size="M" />
            </button>
          </li>
        ))}
      </ul>
      <div className={styles.contentsWrapper__btmArea}>
        {/* TODO:decorationで下線つくのでラップしてます */}
        <div className={styles.contentsWrapper__btnWrap}>
          <Button
            as="a"
            href={generateUrl({
              baseUrl: DODA_SITE_URL.jobHistoryList,
              userClickList: USER_CLICK_HISTORYLIST,
              pathname: router.pathname,
              loginStatus,
            })}
            size="S"
            variant="green"
          >
            最近見た求人一覧へ
          </Button>
        </div>
        <button
          type="button"
          className={styles.contentsWrapper__allDeleteBtn}
          onClick={(e) => {
            e.stopPropagation();
            onClickShowConfirm();
          }}
        >
          一括削除
        </button>
      </div>
    </div>
  );
};
